module.exports = {
  "data": {
    "mechanicalDesign": [{
      "title": "Mechanical Design",
      "text": `AMS works with your engineering team to understand the form, fit, and function of your product. With a complete review of drawings and specifications, you are ensured the highest quality possible.

Our engineering team works closely with your 3D files to determine the best tooling strategy. From there, AMS will study the design and offer suggestions for design changes to improve manufacturability/functionality.`,
      "image": {
        "src": "/images/eng design-1.jpg",
        "alt": "reviewing blueprints",
        "title": "",
        "description": ""
      },
      "cta": {
        "href": "tel:512-987-9874",
        "text": "512-987-9874",
        "icon": "fa-phone-alt"
      }
    }, {
      "title": "Tooling Design & Manufacturing",
      "text": `In order to evaluate the best tooling solution for mass production, the tooling process is a cooperative effort between AMS and the customer:

 - 3D file review and approval with customer
 - Tooling made to run first article samples
 - Customer reviews samples and if approved gives AMS authorization to finish tooling for production.
 - Mass production begins`,
      "image": {
        "src": "/images/cnc mach-tooling.jpg",
        "alt": "working with tools",
        "title": "",
        "description": ""
      },
      "cta": {}
    }, {
      "title": "Part Design & Manufacturing",
      "text": `AMS engineers can take your concept and create the 3D design while bringing that design through all approvals and into mass production.`,
      "image": {
        "src": "/images/rob-wingate-nHRfTeqAxjs-unsplash.jpg",
        "alt": "3d printing",
        "title": "",
        "description": ""
      },
      "cta": {
        "href": "tel:512-987-9874",
        "text": "512-987-9874",
        "icon": "fa-phone-alt"
      }
    }],
    "manufacturingSolutions": [{
      "title": "Manufacturing Solutions",
      "text": `AMS provides a wide range of manufacturing capabilities for mechanical parts.

 - Injection Molding
 - Compression Molding
 - Die Casts
 - Die-Cut
 - Metal Stamping/Forming
 - Extrusions
 - Welding/Machining
 - Powder Coating`,
      "image": {
        "src": "/images/stamping-1 (004).jpg",
        "alt": "measuring on manufacturing floor",
        "title": "",
        "description": ""
      },
      "cta": {
        "href": "tel:512-987-9874",
        "text": "512-987-9874",
        "icon": "fa-phone-alt"
      }
    }, {
      "image": {
        "src": "/images/Plastic Injection_DSF0164_2(002).jpg",
        "alt": "engineering toolset",
        "title": "",
        "description": ""
      }
    }, ],
    "assembly": [{
      "title": "Assembly",
      "text": `AMS has capabilities and resources to provide secondary operations for any mechanical parts we manufacture.

 - Heat-Staking
 - PAD printing
 - Sub-assembly
 - Kitting
 - Packaging
 - System Testing`,
      "image": {
        "src": "/images/ams_Business_01_11.png",
        "alt": "Assembly line",
        "title": "",
        "description": ""
      },
      "cta": {}
    }, {
      "image": {
        "src": "/images/Die cut_DSF0300_assy(002).jpg",
        "alt": "building things",
        "title": "",
        "description": ""
      }
    }],
    "engineering": [{
      "title": "Engineering",
      "text": "",
      "image": {
        "src": "/images/eng design-1.jpg",
        "alt": "engineering toolset",
        "title": "",
        "description": ""
      },
      "cta": {
        "href": "tel:512-987-9874",
        "text": "512-987-9874",
        "icon": "fa-phone-alt"
      }
    }, {
      "image": {
        "src": "/images/eng-1.jpg",
        "alt": "engineering toolset",
        "title": "",
        "description": ""
      }
    }, {
      "title": "Design For Manufacturing",
      "text": `Our engineering team will provide thorough analysis of customer’s design and provide a detailed report of any proposed changes to enhance the manufacturability of the product and provide the best cost.`,
      "image": {},
      "cta": {}
    }, {
      "title": "Prototyping",
      "text": `AMS has complete prototyping capabilities to provide our customers with the design options needed to meet their requirements.`,
      "image": {
        "src": "/images/18.jpg",
        "alt": "prototype",
        "title": "",
        "description": ""
      },
      "cta": {
        "href": "tel:512-987-9874",
        "text": "512-987-9874",
        "icon": "fa-phone-alt"
      }
    }, {
      "title": "DFMEA (Design Failure Mode and Effects Analysis)",
      "text": `A very structured process that requires both the customer and AMS engineers to dissect the design for potential failure modes and design changes if needed.`,
      "image": {},
      "cta": {}
    }, {
      "title": "PFMEA (Process Failure Mode and Effects Analysis)",
      "text": `If assembly is required an analysis of the process is reviewed to see if there are any possible failure modes and change the process to eliminate the failure mode.`,
      "image": {
        "src": "/images/thomas-drouault-IBUcu_9vXJc-unsplash.jpg",
        "alt": "reviewing and inspecting work",
        "title": "",
        "description": ""
      },
      "cta": {
        "href": "tel:512-987-9874",
        "text": "512-987-9874",
        "icon": "fa-phone-alt"
      }
    }, {
      "title": "PPAP (Production Part Approval Process)",
      "text": `AMS can provide Level 5 documentation.

- [Production part approval process [Wikipedia]](https://en.wikipedia.org/wiki/Production_part_approval_process)`,
      "image": {},
      "cta": {}
    }, {
      "title": "(FAI) First Article Inspection Report",
      "text": `FAI is standard process that AMS uses to ensure customer is satisfied with the tooling prior to going to mass production. FAI samples are provided free of charge to the customer for their review. No production will begin until FAI’s are approved by customer.`,
      "image": {
        "src": "/images/FAI.jpg",
        "alt": "Report of the first article inspection.",
        "title": "",
        "description": ""
      },
      "cta": {}
    }, {
      "title": "Metrology",
      "text": `AMS provides complete dimensional inspection of products manufactured using state of the art measurement equipment.`,
      "image": {
        "src": "/images/CMM Insp-Best.jpg",
        "alt": "A coordinate measuring machine, a tool to make 3D measurements.",
        "title": "",
        "description": ""
      },
      "cta": {}
    }, {
      // "title": "Mold Flow Analysis",
      // "text": `(DG will provide content)`,
      // "image": {
      //   "src": "https://picsum.photos/1000",
      //   "alt": "...",
      //   "title": "",
      //   "description": ""
      // },
      // "cta": {}
    }, {
      "title": "Packaging Design",
      "text": `AMS engineering team will design and manufacturer packaging for bulk shipping to customer and /or final packaging. Packaging is designed to optimize shipping costs and provide protection from shipping / handling process.`,
      "image": {
        "src": "/images/bench-accounting-MGaFENpDCsw-unsplash.jpg",
        "alt": "opening a box",
        "title": "",
        "description": ""
      },
      "cta": {
        "href": "tel:512-987-9874",
        "text": "512-987-9874",
        "icon": "fa-phone-alt"
      }
    }],
    "logistics": [{
      "title": "Logistics",
      "text": `AMS provides our customers with total dock to dock services. Our customers can be as involved as they like or let us handle the process of getting product from China to the US.`,
      "image": {
        "src": "/images/frank-mckenna-tjX_sniNzgQ-unsplash.jpg",
        "alt": "Dock to dock",
        "title": "",
        "description": ""
      },
      "cta": {
        "href": "tel:512-987-9874",
        "text": "512-987-9874",
        "icon": "fa-phone-alt"
      }
    }, {
      "image": {
        "src": "/images/chuttersnap-fN603qcEA7g-unsplash.jpg",
        "alt": "Shipping containers",
        "title": "",
        "description": ""
      }
    }, {
      "title": "Shipping",
      "text": `AMS logistics team evaluates the product, ships to location, schedules for delivery, and works with freight forwarders for best pricing and convenience to fit the customers budget and schedule.`,
      "image": {},
      "cta": {}
    }, {
      "title": "Import/Export",
      "text": `AMS can provide complete entry services to our or the customer’s warehouse.`,
      "image": {
        "src": "/images/elevate-dI-aXC7DWpQ-unsplash.jpg",
        "alt": "Moving the shipment",
        "title": "",
        "description": ""
      },
      "cta": {}
    }, {
      "title": "Warehousing",
      "text": `AMS currently has approximately 20k square feet of warehousing. Another 50k of warehousing is under construction due to be ready for use in Q1-2020. AMS can provide our customers with short or long-term storage  with ship on demand to your facility.`,
      "image": {
        "src": "/images/ams_Business_01_12.png",
        "alt": "warehousing storage",
        "title": "",
        "description": ""
      },
      "cta": {
        "href": "tel:512-987-9874",
        "text": "512-987-9874",
        "icon": "fa-phone-alt"
      }
    }],
    "supplyChainManagement": [{
      "title": "Supply Chain Management",
      "text": `Our end-to-end supply chain capabilities are critical to our overall quality, value, and customer satisfaction, and we manage this function accordingly.

 - Supplier Qualification
 - Supplier Audits
 - Quality/Costs/Schedule Management`,
      "image": {
        "src": "/images/supply-chain1.jpg",
        "alt": "management quality review",
        "title": "",
        "description": ""
      },
      "cta": {
        "href": "tel:512-987-9874",
        "text": "512-987-9874",
        "icon": "fa-phone-alt"
      }
    }]
  }
}
